import { jsx as _jsx } from "react/jsx-runtime";
import { useDebounce } from "./useDebounce";
import { SSpinner } from "../SSpinner";
export const useAsyncValidation = ({ value, debounce = {
    time: 1000
}, useQuery, validationPasses = (data)=>!!data })=>{
    const debouncedValue = useDebounce(value, debounce.time);
    const { data: resourceData, isLoading: _isLoading } = useQuery(value, {
        refetchOnMount: false,
        enabled: !!debouncedValue,
        keepPreviousData: true,
        staleTime: 100_000,
        retry: false,
        onError: ()=>{},
        suspense: false
    });
    const isLoading = !!debouncedValue && _isLoading || JSON.stringify(value) !== JSON.stringify(debouncedValue);
    const status = isLoading ? /*#__PURE__*/ _jsx(SSpinner, {}) : !!debouncedValue ? validationPasses(resourceData) ? "✅" : "❌" : "";
    return {
        data: resourceData,
        status,
        found: !validationPasses(resourceData),
        allowSubmit: !isLoading && validationPasses(resourceData) && typeof value !== "undefined"
    };
};
